import { createFriends, type Friends } from './friends.svelte';

let instance: Friends | null = null;

/**
 * Returns the singleton Friends connection. Creates it on first call (must be
 * in browser). Safe to call from multiple components — they all share state.
 */
export function getFriends(userId: string): Friends {
	if (!instance) {
		instance = createFriends(userId);
	}
	return instance;
}

export function disconnectFriends() {
	instance?.disconnect();
	instance = null;
}
